import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import * as procService from "../../services/procService";
import { DataTable, ProcBadge, amount, csvStamp, downloadCsv } from "./procUi";
import { AppDropdown, EmptyState, LoadState, PageHeader, SecondaryButton, formatDate, pageStyle, useLoad } from "../../components/ui";

// Awards (buyer side): every award and where it stands in approval. An award is made on the RFQ's Award tab.
const STATUS_LABEL = { DRAFT: "Draft", PENDING_APPROVAL: "Waiting for approval", APPROVED: "Approved", REJECTED: "Rejected", WITHDRAWN: "Withdrawn" };
const FILTERS = [{ label: "All awards", value: null }, ...Object.entries(STATUS_LABEL).map(([value, label]) => ({ label, value }))];

export default function Awards() {
  const navigate = useNavigate();
  const [status, setStatus] = useState(null);
  const { data, loading, error, reload } = useLoad(() => procService.listAwards({ status }), [status]);
  const exportCsv = () =>
    downloadCsv(`awards-${csvStamp()}.csv`, ["Award", "RFQ", "Title", "Status", "Suppliers", "Currency", "Total", "Sent"], (data || []).map((a) => [a.award_number || "", a.rfq_number, a.rfq_title, STATUS_LABEL[a.status], a.supplier_count, a.currency, a.total, a.submitted_at || ""]));
  return (
    <div style={pageStyle}>
      <PageHeader title="Awards" subtitle="Who was chosen from each RFQ, and whether it has been approved" actions={<SecondaryButton onClick={exportCsv} disabled={!(data || []).length}>Export CSV</SecondaryButton>} />
      <div className="mb-3" style={{ maxWidth: 260 }}>
        <AppDropdown id="proc-award-status" value={status} options={FILTERS} onChange={(e) => setStatus(e.value ?? null)} aria-label="Status" />
      </div>
      <LoadState loading={loading} error={error} onRetry={reload}>
        <DataTable
          rows={data || []}
          onRowClick={(a) => navigate(`/proc/rfqs/${a.rfq_id}`)}
          empty={<EmptyState title={status ? "No awards with this status" : "No awards yet"} text="Open an RFQ that has quotations and use its Award tab." />}
          columns={[
            { label: "Award", render: (a) => <strong>{a.award_number || "Draft"}</strong> },
            { label: "RFQ", render: (a) => <><div>{a.rfq_title}</div><div style={{ fontSize: 12, color: "#6B7280" }}>{a.rfq_number}</div></> },
            { label: "Status", render: (a) => <ProcBadge status={a.status === "APPROVED" ? "AWARDED" : a.status} label={STATUS_LABEL[a.status]} /> },
            { label: "Suppliers", render: (a) => a.supplier_count },
            { label: "Total", render: (a) => `${a.currency} ${amount(a.total)}`, style: { whiteSpace: "nowrap" } },
            { label: "Sent", render: (a) => (a.submitted_at ? formatDate(a.submitted_at) : "—") },
          ]}
        />
      </LoadState>
    </div>
  );
}
